import { useEffect } from "react";

// react router
import { useParams } from "react-router-dom";

// api calls
import { useSample } from "./../api";

// components
import SampleInformation from "../components/ViewSample/SampleInformation";
import SampleResults from "../components/ViewSample/SampleResults";
import OtherResults from "../components/ViewSample/OtherResults";
import Notes from "../components/Notes";

import Footer from "./../components/Footer";
import Navbar from "../components/SpectraNavbar";
import { CardA } from "./../components/ui/Cards";

export default function ViewSample() {
  const { id } = useParams();

  // api
  const { data: sample, isError, isSuccess, isLoading } = useSample(id);

  useEffect(() => {
    console.log("sample:", sample);
  }, [sample]);

  if (isError) {
    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <CardA title='Sample not found' />
        </div>
        <Footer />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <div
            className='alert mx-3'
            style={{
              backgroundColor: "#7ECBF7",
              fontWeight: "bold",
            }}
            role='alert'
          >
            Fetching sample ...
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className='flex-container'>
        <Navbar signedIn={false} />
        <div
          className='px-sm-3 px-lg-5 py-3 flex-body'
          style={{ marginTop: "79px" }}
        >
          <CardA>
            <button
              type='button'
              className='back-button'
              onClick={() => {
                window.history.back();
              }}
            >
              <i className='bi bi-arrow-left pe-1'></i>
              Back
            </button>
            <div className='h4'>Results Summary</div>

            <div className='row full-height'>
              <SampleInformation sample={sample} />
            </div>
            <div className='row full-height'>
              <SampleResults sample={sample} />
            </div>
            <div className='row full-height'>
              <div className='my-2 full-height'>
                <div className='card full-height'>
                  <div className='card-body'>
                    <Notes
                      id={sample._id}
                      savedNotes={sample.notes}
                      type='sample'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='row full-height'>
              <OtherResults
                id={sample._id}
                otherResults={sample.otherResults}
              />
            </div>
          </CardA>
        </div>
        <Footer />
      </div>
    );
  }
  return null;
}
